import { Link, Typography } from "@mui/material";
import { Links, SystemStatus } from "../../constants";
import { FeedItemDto, FeedItemMetricDatasetValueDto } from "../../http";

interface IProps {
  feedItem: FeedItemDto;
}

const MetricDatasetPropertyChange = (props: IProps) => {
  if (props.feedItem.propertyChange!.changeType === SystemStatus.Created) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> added the dataset </span>
        <strong>{props.feedItem.propertyChange!.value}</strong>
      </Typography>
    );
  }

  if (props.feedItem.propertyChange!.changeType === SystemStatus.Deleted) {
    return (
      <Typography variant="caption">
        <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
        <span> removed the dataset </span>
        <strong>{props.feedItem.propertyChange!.value}</strong>
      </Typography>
    );
  }

  const value = props.feedItem.propertyChange!.value as FeedItemMetricDatasetValueDto;

  return (
    <Typography variant="caption">
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link>
      <span> changed a dataset's title from </span>
      <strong>{value.oldTitle}</strong>
      <span> to </span>
      <strong>{value.newTitle}</strong>
    </Typography>
  );
};

export { MetricDatasetPropertyChange };
